<template>
    <div class="all-active-invest">
        <div class="box-border" v-if = "planInvestmentAmount !== null && planTotalEarnings !== null && showEmptyState">
            <div class="all-active-invest__lists">
                <div class="all-active-invest__lists--items">
                    <strong class="main-title">{{percentage}}%</strong>
                    <p class="mb-0 sub-title"> {{percentageReturnTitle}}</p>
                </div>
                <div class="all-active-invest__lists--items">
                    <strong class="main-title">&#x20B9; {{planInvestmentAmount | localeAmountPaisa}}</strong>
                    <p class="mb-0 sub-title">Invested Value</p>
                </div>
                <div class="all-active-invest__lists--items" v-if = "currentTabItem === 'growthConservative' || currentTabItem === 'growthAggressive'">
                    <strong class="main-title">&#x20B9; {{planTotalAmount | localeAmountPaisa}}</strong>
                    <p class="mb-0 sub-title">Account Value</p>
                </div>
                <div class="all-active-invest__lists--items" v-if="!earningsTillDate">
                    <strong class="main-title">&#x20B9; {{planTotalEarnings | localeAmountPaisa}}</strong>
                    <p class="mb-0 sub-title">Total Earnings</p>
                </div>
                <div class="all-active-invest__lists--items" v-else>
                    <strong class="main-title">&#x20B9; {{firstExpectedEarnings | localeAmountPaisa}}</strong>
                    <p class="mb-0 sub-title">First Expected Earnings</p>
                </div>
            </div>
            <div class="mt-30">
                <GrowthChart
                    v-if="!isLoadingGrowth && showEmptyState"
                    :investAmount="investAmount"
                    :totalAmount="totalAmount"
                    :date="date"
                />
                <div v-if = "isNotActive">
                    <noActiveInvestmentState :interest="percentage"/>
                </div>
                <incomeChart
                    v-else-if="!isLoadingIncome && showEmptyState"
                    :totalAmount="totalAmount"
                    :date="date"
                />
            </div>
        </div>
        <div v-if = "planInvestmentAmount !== null && planTotalEarnings === null && showEmptyState">
            <valueDeploymentState/>
        </div>
        <div v-else-if = "planInvestmentAmount === null && planTotalEarnings === null && showEmptyState">
            <valueEmptyState/>
        </div>
    </div>
</template>
<script>
import incomeChart from './incomePortfolioChart.vue'
import GrowthChart from './incomeChart.vue'
import valueDeploymentState from '@/components/dashboard/valueDeploymentState.vue'
import valueEmptyState from '@/components/dashboard/valueEmptyState.vue'
import noActiveInvestmentState from '@/components/dashboard/noActiveInvestmentState.vue'
import LenderService from '@/services/lenderService'

export default {
    name: 'AllActiveInvestment',
    components: {
        incomeChart,
        GrowthChart,
        valueDeploymentState,
        valueEmptyState,
        noActiveInvestmentState
    },
    props: {
        currentTabItem: String
    },
    watch: {
        currentTabItem: function (newVal, oldVal) {
            this.expectedEarningPlan()
        }
    },
    data () {
        return {
            firstInvestmentAmount: null,
            firstInvestmentDate: null,
            planTotalAmount: 0,
            planInvestmentAmount: null,
            planTotalEarnings: null,
            firstExpectedEarnings: null,
            earningsTillDate: false,
            date: [],
            investAmount: [],
            totalAmount: [],
            isLoadingGrowth: true,
            isLoadingIncome: false,
            percentageReturnTitle: 'p.a.',
            percentage: null,
            showEmptyState: false,
            isNotActive: false
        }
    },
    mounted () {
    },
    methods: {
        expectedEarningPlan () {
            this.$store.commit('isLoading')
            this.resetValues()
            var query = '&plan=' + this.currentTabItem
            LenderService.graphInvestmentData(query).then((response) => {
                if (response.status === 200) {
                    this.$store.commit('isNotLoading')
                    if (response.data.accountData[0]?.totalAmount) {
                        this.planTotalAmount = response.data.accountData[0].totalAmount
                    } else {
                        this.isNotActive = true
                    }
                    if (!response.data.earningsData[0]?.expectedInterest) {
                        this.showEmptyState = true
                    }
                    this.planInvestmentAmount = response.data.accountData[0].investedAmount
                    if ('paidInterest' in response.data.earningsData[0]) {
                        this.planTotalEarnings = response.data.earningsData[0].paidInterest
                        if (this.planTotalEarnings === 0) {
                            this.getFirstExpectedEarnings()
                        } else if (this.planTotalEarnings > 0) {
                            this.getRealGraph()
                        }
                    }
                }
            })
        },
        getRealGraph () {
            if (this.currentTabItem === 'incomeAggressive' || this.currentTabItem === 'incomeConservative') {
                this.incomeRealGraph()
            } else if (this.currentTabItem === 'growthAggressive' || this.currentTabItem === 'growthConservative') {
                this.isNotActive = false
                this.growthRealGraph()
            }
        },
        growthRealGraph () {
            this.$store.commit('isLoading')
            var query = '&plan=' + this.currentTabItem
            LenderService.growthGraphData(query).then((response) => {
                if (response.status === 200) {
                    this.$store.commit('isNotLoading')
                    this.date = response.data.dateArray
                    this.investAmount = response.data.investedAmountArray
                    this.totalAmount = response.data.totalAmountArray
                    this.percentage = Math.round(response.data.apr * 10) / 10
                    this.isLoadingGrowth = false
                    this.showEmptyState = true
                }
            })
        },
        incomeRealGraph () {
            this.$store.commit('isLoading')
            var query = '&plan=' + this.currentTabItem
            LenderService.incomeGraphData(query).then((response) => {
                if (response.status === 200) {
                    this.$store.commit('isNotLoading')
                    this.date = response.data.dateArray
                    this.totalAmount = response.data.earningsArray
                    this.percentage = Math.round(response.data.apr * 10) / 10
                    this.isLoadingIncome = false
                    this.showEmptyState = true
                }
            })
        },
        getFirstExpectedEarnings () {
            this.$store.commit('isLoading')
            var query = '&plan=' + this.currentTabItem
            LenderService.getFirstExpectedEarnings(query).then((response) => {
                if (response.status === 200) {
                    this.$store.commit('isNotLoading')
                    if (response.data.firstExpectedEarnings[0]?.interest) {
                        this.firstExpectedEarnings = response.data.firstExpectedEarnings[0]?.interest
                    }
                    this.firstInvestmentAmount = response.data.firstInvestmentDetails[0].firstInvestmentAmount
                    this.firstInvestmentDate = response.data.firstInvestmentDetails[0].firstInvestmentDate
                    this.earningsTillDate = true
                    this.plotExpectedEarningGraph()
                }
            })
        },
        plotExpectedEarningGraph () {
            if (this.currentTabItem === 'incomeAggressive' || this.currentTabItem === 'incomeConservative') {
                this.incomeExpectedGraph()
            } else if (this.currentTabItem === 'growthAggressive' || this.currentTabItem === 'growthConservative') {
                this.isNotActive = false
                this.growthExpectedGraph()
            }
        },
        incomeExpectedGraph () {
            this.$store.commit('isLoading')
            var query = '&plan=' + this.currentTabItem
            LenderService.incomeExpectedGraphData(query).then((response) => {
                if (response.status === 200) {
                    this.$store.commit('isNotLoading')
                    this.date = response.data.dateArrayFinal
                    this.totalAmount = response.data.earningsArray
                    this.isLoadingIncome = false
                    this.percentage = response.data.percentage
                    this.showEmptyState = true
                }
            })
        },
        growthExpectedGraph () {
            this.$store.commit('isLoading')
            var query = '&plan=' + this.currentTabItem
            LenderService.growthExpectedGraphData(query).then((response) => {
                if (response.status === 200) {
                    this.$store.commit('isNotLoading')
                    this.date = response.data.dateArray
                    this.investAmount = response.data.investedAmountArray
                    this.totalAmount = response.data.totalAmountArray
                    this.isLoadingGrowth = false
                    this.percentage = response.data.percentage
                    this.showEmptyState = true
                }
            })
        },
        resetValues () {
            this.planInvestmentAmount = null
            this.planTotalAmount = 0
            this.planTotalEarnings = null
            this.firstExpectedEarnings = null
            this.firstInvestmentAmount = null
            this.firstInvestmentDate = null
            this.earningsTillDate = false
            this.date = []
            this.investAmount = []
            this.totalAmount = []
            this.isLoadingGrowth = true
            this.isLoadingIncome = true
            this.percentage = null
            this.showEmptyState = false
        }
    }
}
</script>
<style lang="scss" scoped>
    @import "~@/sass/components/_dashboard-layout.scss";
    .all-active-invest__lists {
        border-radius: 12px;
        background-color: #f2f6ff;
        padding: 28px;
        padding-left: 12px;
        padding-right: 12px;
    }
    .all-active-invest{
        &__lists{
            @include flex(flex, center, space-between);
            &--items{
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                .main-title {
                    font-size: 21px;
                    color: #232323;
                    font-weight: 700;
                }
                .sub-title {
                    color: #4f4f4f;
                    font-size: 13px;
                    font-weight: $font-weight-medium;
                }
            }
        }
        select {
            border: 0;
            padding: 0 10px;
        }
        &__content {
            display: flex;
            flex-wrap: wrap;
            flex-direction: column;
            margin-left: -15px;
            margin-right: -15px;
            margin-top: 15px;
            margin-bottom: 0;
            @media (min-width: 992px) {
                flex-wrap: nowrap;
                flex-direction: row;
                margin-left: -30px;
                margin-right: -30px;
            }
            .blue-gr {
                flex: 1;
                margin: 15px 15px;
                display: flex;
                align-items: center;
                @media (min-width: 992px) {
                    margin: 30px;
                }
            }
        }
    }

    @media (max-width:768px) {
    .all-active-invest{
        &__lists{
            @include flex(flex, center, space-between);
            &--items{
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                .main-title {
                    font-size: 15px;
                    color: #232323;
                    font-weight: 700;
                }
                .sub-title {
                    color: #4f4f4f;
                    font-size: 11px;
                    font-weight: $font-weight-medium;
                }
            }
        }
    }
}

    @media (max-width:480px) {
    .all-active-invest{
        &__lists{
            @include flex(flex, center, space-between);
            &--items{
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                .main-title {
                    font-size: 14px;
                    color: #232323;
                    font-weight: 700;
                }
                .sub-title {
                    color: #4f4f4f;
                    font-size: 8px;
                    font-weight: $font-weight-medium;
                }
            }
        }
    }
}
    .box-border {
        padding-top: 15px;
        border-radius: 0px !important;
        height: max-content !important;
    }
 </style>
